import React, { useContext, useEffect } from "react";
import "./styles/Header.scss";
import SearchHeader from "../SearchHeader/SearchHeader";
import SearchIcon from "../VectorIcons/SearchIcon";
import MobileSearch from "../MobileSearch/MobileSearch";
import AppContext from "../../context/appContext";
import UserContext from "../../context/userContext";
import LogoLink from "./LogoLink/LogoLink";
import AvatarData from "./AvatarData/AvatarData";
import Menu from "./Menu/Menu";
import { useLocation } from "react-router-dom";
import useNavigationMenuLinks from "../../hooks/useNavigationMenuLinks";

const Header = () => {
  const appContext = useContext(AppContext);
  const { me, userIsRole, userIsOnlyRole, getFullName } =
    useContext(UserContext);

  const location = useLocation();

  const isTextRelaseRole = userIsRole("Channel");
  const isOnlyAttachmentViewer = userIsOnlyRole("AttachmentViewer");
  const canSeeSearchBar = !isTextRelaseRole && !isOnlyAttachmentViewer;

  const userName = getFullName();
  const { allowedPages, showNavigationMenu } = useNavigationMenuLinks();

  useEffect(() => {
    const body = document.querySelector("body");
    const currentStep = appContext.current.step;
    const hasCurrentStep = !!currentStep;
    const canScroll = !hasCurrentStep || currentStep === "closed";
    body.style.overflow = !!canScroll ? "auto" : "hidden";
    // eslint-disable-next-line
  }, [appContext.current]);

  return (
    <header id="Header">
      {location.pathname !== "/" && (
        <>
          <LogoLink />

          {!me.loading && canSeeSearchBar && <SearchHeader />}
        </>
      )}

      {!me.loading && (
        <>
          {appContext.showMobileSearch && canSeeSearchBar && <MobileSearch />}

          <nav onClick={() => appContext.setRedirectSearch(false)}>
            {canSeeSearchBar && (
              <div
                className="navItem mobileSearchIcon"
                onClick={() => appContext.setShowMobileSearch(true)}
              >
                <SearchIcon strokeCollor="#17b4e1" />
              </div>
            )}

            <AvatarData name={userName} />

            {showNavigationMenu && <Menu menuLinks={allowedPages} />}
          </nav>
        </>
      )}
    </header>
  );
};

export default Header;
